module.exports = __webpack_public_path__ + "static/media/test13_1.cfc924e1.png";